// 进行模块的 单独路由
// 导入模块
import partner from '../components/partner';


// 配置路由
export default{
    path:"/partner",
    component:partner,
}


// WEBPACK FOOTER //
// ./src/router/partner.js